---
nb:
  errors:
    invalid_number: Angi et gyldig tall
